module.exports = __webpack_public_path__ + "img/line_castle.9b802340.png";